/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";
import {
  SearchChatsFilter,
  SearchChatsFilter$Outbound,
  SearchChatsFilter$outboundSchema,
} from "./searchchatsfilter.js";

/**
 * Sort order
 */
export const SearchChatsPayloadSort = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort order
 */
export type SearchChatsPayloadSort = ClosedEnum<typeof SearchChatsPayloadSort>;

/**
 * Payload for searching chat session summaries
 */
export type SearchChatsPayload = {
  /**
   * Cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Filter criteria for searching chat sessions
   */
  filter?: SearchChatsFilter | undefined;
  /**
   * Number of items to return (1-1000)
   */
  limit?: number | undefined;
  /**
   * Sort order
   */
  sort?: SearchChatsPayloadSort | undefined;
};

/** @internal */
export const SearchChatsPayloadSort$outboundSchema: z.ZodMiniEnum<
  typeof SearchChatsPayloadSort
> = z.enum(SearchChatsPayloadSort);

/** @internal */
export type SearchChatsPayload$Outbound = {
  cursor?: string | undefined;
  filter?: SearchChatsFilter$Outbound | undefined;
  limit: number;
  sort: string;
};

/** @internal */
export const SearchChatsPayload$outboundSchema: z.ZodMiniType<
  SearchChatsPayload$Outbound,
  SearchChatsPayload
> = z.object({
  cursor: z.optional(z.string()),
  filter: z.optional(SearchChatsFilter$outboundSchema),
  limit: z._default(z.int(), 50),
  sort: z._default(SearchChatsPayloadSort$outboundSchema, "desc"),
});

export function searchChatsPayloadToJSON(
  searchChatsPayload: SearchChatsPayload,
): string {
  return JSON.stringify(
    SearchChatsPayload$outboundSchema.parse(searchChatsPayload),
  );
}
